import Vue from 'vue';
import VueMask from 'vue-the-mask';
import i18n from './locales';
import App from './App';
import router from './router';
import store from './store';
import './validations';
import './components/globals';
import './filters/percentage';
import './filters/formatDate';

Vue.config.productionTip = false;

Vue.use(VueMask);

require('@fortawesome/fontawesome-pro/css/all.css');

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
